import { END_POINTS } from '../helpers';
import { VehicleModelData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetVehicleModelResponse = {
  count: number;
  data: VehicleModelData[];
};

export const vehicleModelApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleModel: builder.query<
      CommonResponse & { data: GetVehicleModelResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getVehicleModel}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteVehicleModel: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteVehicleModel}/${id}`,
        method: 'DELETE',
      }),
    }),
    getVehicleModelById: builder.query<CommonResponse & { data: VehicleModelData }, { id: string }>(
      {
        query: ({ id }) => ({
          url: `${END_POINTS.getVehicleModelById}/${id}`,
          method: 'GET',
        }),
      }
    ),

    addVehicleModel: builder.mutation<
      CommonResponse & { data: VehicleModelData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addVehicleModel}`,
        method: 'POST',
        body,
      }),
    }),
    updateVehicleModel: builder.mutation<
      CommonResponse & { data: VehicleModelData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateVehicleModel}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddVehicleModelMutation,
  useUpdateVehicleModelMutation,
  useLazyGetVehicleModelQuery,
  useLazyDeleteVehicleModelQuery,
  useLazyGetVehicleModelByIdQuery,
} = vehicleModelApi;
